import { gql, useQuery } from '@apollo/client';
import removeNullObjectKeys from '../utils/removeNullObjectKeys';

const getQuery = gql`
  query reviewAggregates(
    $listingId: String
    $categoryId: String
    $suburbName: String
    $state: String
  ) {
    reviewAggregates(
      listingId: $listingId
      categoryId: $categoryId
      suburbName: $suburbName
      state: $state
    ) {
      averageRating
      count
    }
  }
`;

const useReviewAggregates = params => {
  const { listingId, categoryId, suburbName, state } = params || {};

  const variables = removeNullObjectKeys({
    listingId: listingId ? listingId && listingId.toString() : null,
    categoryId: categoryId ? categoryId && categoryId.toString() : null,
    suburbName,
    state,
  });

  const { data, loading } = useQuery(getQuery, {
    variables,
  });

  const { reviewAggregates = {} } = data || {};

  return {
    reviewAggregates,
    loading,
  };
};

export default useReviewAggregates;
